import { useEffect } from 'react';
import { useLayoutStore } from '@/stores/useLayoutStore';

export function useHideBottomNav(hide = true) {
  const setHideBottomNav = useLayoutStore(state => state.setHideBottomNav);
  
  useEffect(() => {
    // Set bottom nav visibility immediately
    setHideBottomNav(hide);
    
    // Clean up on unmount - show the bottom nav again
    return () => {
      setHideBottomNav(false);
    };
  }, [hide, setHideBottomNav]);
} 